package com.essntl.core.settings.data.supabase.configuration

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonElement

@Serializable
data class ConfigurationDto(
    @SerialName("setting_key")
    val settingKey: String,
    @SerialName("setting_value")
    val settingValue: JsonElement,
)
